import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';

import CardIcon from './CardIcon';
import './styles/simpleTable.css';

const styles = {
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'inherit',
    textAlign: 'right',
    padding: 16,
    minHeight: 85,
    cursor: 'pointer',
  },
  cardLabel: {
    paddingLeft: 85,
  },
  cardValue: {
    paddingLeft: 85,
    fontSize: 30,
    fontWeight: 'bold',
  },
  dnone: {
    display: 'none',
  },
};

const DefaultTbody = ({ list, state }) => {
  return (
    <tbody>
      <tr>
        <th>id</th>
        <th>telefono</th>
        <th>email</th>
      </tr>
      {list.map((item, index) => (
        <tr key={index}>
          <td>{item.id}</td>
          <td>{item.phone_number || ''}</td>
          <td>{item.email}</td>
        </tr>
      ))}
    </tbody>
  );
};

class CardStats extends Component {
  constructor(props) {
    super(props);

    const { Icon, iconBgColor, label, value, tbody, list = [] } = props;

    this.Icon = Icon;
    this.iconBgColor = iconBgColor;
    this.label = label;
    this.value = value;
    this.list = list;
    this.tbody = tbody;

    this.state = {
      isOpen: false,
    };

    this.contentRef = React.createRef();
  }

  toggleCollapse = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    return (
      <React.Fragment>
        <CardIcon Icon={this.Icon} bgColor={this.iconBgColor} toggleCollapse={this.toggleCollapse} />

        <Card style={styles.card} onClick={this.toggleCollapse}>
          <Typography color="textSecondary" style={styles.cardLabel}>
            {this.label}
          </Typography>

          <Typography variant="headline" component="h1" style={styles.cardValue}>
            {this.value}
          </Typography>

          <table id="simple-table" style={this.state.isOpen ? {} : styles.dnone} onClick={e => e.stopPropagation()}>
            {this.tbody || <DefaultTbody list={this.list} state={this.state} />}
          </table>
        </Card>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CardStats);



// WEBPACK FOOTER //
// ./src/components/CardStats.js